import React from 'react';
import { useNavigate } from 'react-router-dom';
import './../common.css'; // Import common CSS styles
import logo from '../Images/logo.png'; // Import the logo

function LandingPage() {
  const navigate = useNavigate();

  const handleEnterClick = () => {
    window.open('/atsg/home', '_blank');
  };

  const handleCloudACSClick = () => {
    window.open('https://cloudacs.crestron.io/', '_blank');
  };

  const handleIncidentReportClick = () => {
    window.open('https://lemon-pebble-028633610.1.azurestaticapps.net/', '_blank');
  };

  const handleDevOpsToolsClick = () => {
    window.open('/devops-tools', '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-800 via-blue-900 to-slate-900 flex flex-col">
      {/* Main Content - Centered Vertically */}
      <div className="flex-1 flex flex-col items-center justify-center px-8">
        {/* Welcome Section */}
        <div className="text-center mb-12">
          <h1 className="text-6xl font-bold text-white mb-4 drop-shadow-lg">
            Welcome to
          </h1>
          <h2 className="text-4xl font-semibold text-cyan-300 mb-6 drop-shadow-lg">
            Crestron XiO Support Tools
          </h2>
        </div>

        {/* Buttons - Centered */}
        <div className="flex flex-row gap-6 items-center justify-center max-w-6xl flex-wrap">
          <button
            onClick={handleEnterClick}
            className="group relative bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-bold py-4 px-12 rounded-full shadow-2xl shadow-cyan-500/30 transform transition-all duration-300 hover:scale-105 hover:shadow-cyan-500/50 focus:outline-none focus:ring-4 focus:ring-cyan-500/50"
          >
            <span className="text-xl">SAAS Tool</span>
          </button>
          
          <button
            onClick={handleCloudACSClick}
            className="group relative bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-bold py-4 px-12 rounded-full shadow-2xl shadow-cyan-500/30 transform transition-all duration-300 hover:scale-105 hover:shadow-cyan-500/50 focus:outline-none focus:ring-4 focus:ring-cyan-500/50"
          >
            <span className="text-xl">CloudACS</span>
          </button>
          
          <button
            onClick={handleIncidentReportClick}
            className="group relative bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-bold py-4 px-12 rounded-full shadow-2xl shadow-cyan-500/30 transform transition-all duration-300 hover:scale-105 hover:shadow-cyan-500/50 focus:outline-none focus:ring-4 focus:ring-cyan-500/50"
          >
            <span className="text-xl">Incident Report</span>
          </button>
          
          <button
            onClick={handleDevOpsToolsClick}
            className="group relative bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-bold py-4 px-12 rounded-full shadow-2xl shadow-cyan-500/30 transform transition-all duration-300 hover:scale-105 hover:shadow-cyan-500/50 focus:outline-none focus:ring-4 focus:ring-cyan-500/50"
          >
            <span className="text-xl">DevOps Tools</span>
          </button>
        </div>
      </div>

      {/* Features Preview - Bottom */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-6xl mx-auto p-8">
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
          <h3 className="text-xl font-semibold text-cyan-300 mb-3">SAAS Tool</h3>
          <p className="text-gray-200 text-sm">
            Manage devices, users, recovery email, and recovery phone
          </p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
          <h3 className="text-xl font-semibold text-cyan-300 mb-3">CloudACS</h3>
          <p className="text-gray-200 text-sm">
            Crestron cloud-based access control system management platform
          </p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
          <h3 className="text-xl font-semibold text-cyan-300 mb-3">Incident Report</h3>
          <p className="text-gray-200 text-sm">
            Report and track technical incidents and support requests
          </p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
          <h3 className="text-xl font-semibold text-cyan-300 mb-3">DevOps Tools</h3>
          <p className="text-gray-200 text-sm">
            Development and operations tools for system management
          </p>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
